import { Container } from 'rebass';
import styled from 'styled-components';

const ContainerMinWidth = styled(Container)`
  padding-top: 1em; /* 6em; */
  min-width: 320px;

  @media (max-width: 512px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export default ContainerMinWidth;
